import type {Editor} from "slate";

import useRRv5CheckForUnsavedChanges from "./hooks/use-rrv5-check-for-unsaved-changes.ts";

interface Props {
    editor: Editor | null;
    viewOnly: boolean;
}

export const CheckForUnsavedChangesRRv5 = ({editor, viewOnly}: Props) => {
    useRRv5CheckForUnsavedChanges(editor, viewOnly);
    return <></>;
};
